import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";

const controller = rpcController("ComportamientoComercial");

/**Resource del reporte de estadísticas de clientes*/
export const RepComportamientoComercial= cacheResource({
Generar: async (
parametros: models.ParamsComportamientoComercial): Promise<string> =>
await controller("GenerarReporteComportamientoComercial", {}, parametros)
}, {
}, {
})


// WEBPACK FOOTER //
// ./app/resources/items/reportecomportamientocomercial.tsx